const config: Record<string, string> = {
  en: "en",
  nl: "nl",
  ar: "ar",
  ja: "ja",
  de: "de",
  es: "es",
  fr: "fr",
  it: "it",
  ko: "ko",
  pt: "pt",
  tr: "tr",
  uk: "uk",
  vi: "vi",
  zh: "zh",
  zu: "zu",
  ur: "ur",
  az: "az",
  pl: "pl",
  ro: "ro",
};

export const fetchTranslations = async (locale: string) => {
  const availableLocale = config[locale] ? locale : "en";
  const messages = await import(
    `./${config[availableLocale]}/translation.json`
  );

  return {
    locale: availableLocale,
    messages,
  };
};
